export default __webpack_public_path__ + "static/media/header-visu2.64785752.jpg";